// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const git_connectionsSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  provider: z.string().max(200),
  authMethod: z.string().max(200),
  apiHost: z.string().max(200),
  externalAccountId: z.string().max(100),
  externalAccountLogin: z.string().max(200),
  externalAccountType: z.string().max(200),
  tokenVaultRef: z.string().max(200).optional(),
  scopes: z.array(z.string()).optional(),
  permissions: z.record(z.string(), z.unknown()).optional(),
  webhookSecretVaultRef: z.string().max(200).optional(),
  webhookEvents: z.array(z.string()).optional(),
  repoSelection: z.string().max(200).optional(),
  providerData: z.record(z.string(), z.unknown()).optional(),
  status: z.string().max(50),
  suspendedAt: z.string().max(200).optional(),
  archived: z.boolean(),
})

export type Git_connectionsInput = z.infer<typeof git_connectionsSchema>
